<template>
  <div id="catalogos">
    <v-select v-model="solicitud.nombres" label="Seleccione un catálogo" :items="catalogos.catalogos"
      @change="updateTable($event)" item-text="nombre" item-value="tabla"></v-select>
    <v-card class="elevation-12">
      <v-toolbar dense dark color="blue-grey">
        <v-toolbar-title>Elementos del Catálogo</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip v-if="tableName != null" left>
          <v-btn slot="activator" :loading="loading" icon @click="showDialogNewCat()">
            <v-icon>add_box</v-icon>
          </v-btn>
          <span>Nuevo elemento</span>
        </v-tooltip>
      </v-toolbar>
      <v-card-title>
        <v-btn small :loading="loading" color="info" class="white--text" @click="updateTable(null)">Actualizar</v-btn>
        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="search" label="Buscar" single-line hide-details
          maxlength="200"></v-text-field>
      </v-card-title>
      <v-data-table :headers="headers" :items="valores" :loading="loading" :search="search"
        rows-per-page-text="Registros por página" :pagination.sync="pagination" class="elevation-1">
        <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
        <template slot="items" slot-scope="props">
          <td v-for="header in headers" :key="header.value" class="pa-0 ma-0"
            style="vertical-align: middle; text-align: center; cursor: pointer;"
            @click="showDetailElemnt(props.item[headers[0].value])">
            <template v-if="typeof props.item[header.value] === 'boolean'">
              <v-checkbox :input-value="props.item[header.value]" color="primary" hide-details dense readonly
                class="ma-0 pa-0 d-inline-block" @click.stop />
            </template>
            <template v-else-if="isSelectField(header.value)">
              {{ getSelectLabelProp(props.item[header.value] || props.item, header.value) }}
            </template>
            <template v-else>
              {{ props.item[header.value] }}
            </template>
          </td>
        </template>
        <template slot="pageText" slot-scope="props">
          Página {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
        </template>
        <template slot="no-data">
          <v-card-text>
            <center>
              <h3 class="headline">Seleccione un catálogo</h3>
            </center>
          </v-card-text>
        </template>
        <template slot="no-results">
          <div class="text-xs-center">
            No se obtuvieron resultados
          </div>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="dialogNewCat" fullscreen hide-overlay :persistent="true" transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dense dark color="blue-grey">
          <v-btn icon dark :disabled="loading" @click="close()">
            <v-icon>close</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-toolbar-title>Nuevo elemento</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark flat :loading="loading" @click="questionCat = true">Guardar</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm12 md6>
                <v-container>
                  <h3 class="grey--text">Nuevo elemento al catálogo {{ tableName }}</h3><br />
                  <div v-for="(field, index) in newFields" :key="field.key">
                    <template
                      v-if="isBooleanField(field) && !newFields.slice(0, index).some(f => isBooleanField(f))">
                      <div class="text-h4 font-weight-bold mb-1 mt-4">Aplicable a:</div>
                    </template>
                    <!-- SELECT -->
                    <template v-if="field.type === 'select'">
                      <v-select v-model="nuevoCatalogo[field.key]" :item-text="field.label" :item-value="field.value"
                        :items="selectOptions[field.catalog || field.key] || field.options"
                        :label="field.key.replace('_', ' ')"></v-select>
                    </template>
                    <!-- BOOLEAN -->
                    <template v-else-if="isBooleanField(field)">
                      <v-checkbox v-model="nuevoCatalogo[field.key]" :label="booleanFieldLabel(field.key)"
                        hide-details class="ma-0" color="primary" />
                    </template>
                    <!-- NUMBER -->
                    <template v-else-if="field.type === 'number'">
                      <v-text-field v-model.number="nuevoCatalogo[field.key]" :type="'number'" min="0"
                        :label="field.key" flat :rules="numericRules" />
                    </template>
                    <!-- TEXT por defecto -->
                    <template v-else>
                      <v-text-field v-model="nuevoCatalogo[field.key]" :label="field.key" flat />
                    </template>
                  </div>
                </v-container>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogDetCat" fullscreen hide-overlay :persistent="true" transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dense dark color="blue-grey">
          <v-btn icon dark :disabled="loading" @click="closeDetailCat()">
            <v-icon>close</v-icon>
          </v-btn>
          <v-spacer> </v-spacer>
          <v-toolbar-title>Detalle del elemento</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark flat :loading="loading" @click="questionDelCat = true">Eliminar</v-btn>
          </v-toolbar-items>
          <v-toolbar-items>
            <v-btn dark flat :loading="loading" @click="questionUpdCat = true">Actualizar</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm12 md6>
                <v-container>
                  <h3 class="grey--text">Edición de {{ tableName }}</h3><br />
                  <div v-for="(field, index) in editFields" :key="field.key" class="py-2">

                    <!-- LABEL antes del primer booleano -->
                    <template
                      v-if="isBooleanField(field) && !editFields.slice(0, index).some(f => isBooleanField(f))">
                      <div class="text-h4 font-weight-bold mb-1 mt-4">Aplicable a:</div>
                    </template>

                    <!-- SELECT -->
                    <template v-if="field.type === 'select'">
                      <v-select v-model="detalleCatalogo[field.key]" :item-text="field.label" :item-value="field.value"
                        :items="selectOptions[field.catalog || field.key] || field.options"
                        :label="field.key.replace('_', ' ')" :box="!editables[field.key]" />
                    </template>

                    <!-- BOOLEAN -->
                    <template v-else-if="isBooleanField(field)">
                      <v-checkbox v-model="detalleCatalogo[field.key]" :label="booleanFieldLabel(field.key)"
                        hide-details class="ma-0" color="primary" />
                    </template>

                    <!-- NUMBER -->
                    <template v-else-if="field.type === 'number'">
                      <v-text-field v-model.number="detalleCatalogo[field.key]" type="number" :label="field.key" flat
                        :readonly="!editables[field.key]" :box="!editables[field.key]" :rules="numericRules" />
                    </template>

                    <!-- TEXT -->
                    <template v-else>
                      <v-text-field v-model="detalleCatalogo[field.key]" :label="field.key" flat
                        :readonly="!editables[field.key]" :box="!editables[field.key]" />
                    </template>

                  </div>

                </v-container>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="questionCat" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">¿Desea guardar el nuevo elemento?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="questionCat = false">Cancelar</v-btn>
          <v-btn flat color="orange" @click.native="save()">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="questionUpdCat" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">¿Desea actualizar la información del catálogo?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="questionUpdCat = false">Cancelar</v-btn>
          <v-btn flat color="orange" @click.native="update()">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="questionDelCat" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">¿Desea eliminar este elemento del catálogo?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="questionDelCat = false">Cancelar</v-btn>
          <v-btn flat color="error" @click.native="remove()">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="success" color="success" :timeout="2500" bottom right>
      {{ msgSuccess }}
    </v-snackbar>
    <v-snackbar v-model="error" color="error" :timeout="2500" bottom right>
      {{ msgError }}
    </v-snackbar>
    <v-dialog v-model="loading" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Procesando información
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import services from '@/config/services'
import axios from 'axios'
import { newCatalogs, numericRules } from '../utils'

const BOOLEAN_CATALOG_FIELDS = {
  caja_chica: 'Caja chica',
  gastos_viaje: 'Gastos de viaje',
  amex: 'AMEX',
  gastos_representacion: 'Gastos de representación'
}

export default {
  name: 'catalogos',
  data: () => ({
    numericRules,
    loading: false,
    success: false,
    solicitud: {
      nombres: ''
    },
    newCatalogs,
    catalogos: {
      catalogos: [],
      catalogos_estatus: [],
      catalogos_estatus_original: []
    },
    tableName: null,
    headers: [],
    valores: [],
    editables: [],
    search: '',
    pagination: {
      rowsPerPage: 7
    },
    selectDetCat: null,
    dialogDetCat: false,
    dialogNewCat: false,
    questionCat: false,
    questionUpdCat: false,
    questionDelCat: false,
    detalleCatalogo: {},
    nuevoCatalogo: {},
    msgSuccess: '',
    error: false,
    msgError: '',
    selectOptions: {}
  }),
  mounted () {
    this.refresh()
    this.loadAllFieldOptions()
  },
  computed: {
    isNewReq () {
      return this.dialogNewReq
    },
    isNewCatalog () {
      return this.newCatalogs.find(c => c.tabla === this.tableName) || null
    },
    newFields () {
      if (this.isNewCatalog) {
        return this.isNewCatalog.fields
      }
      return this.headers.map(h => this.mapLegacyField(h.text))
    },
    editFields () {
      if (this.isNewCatalog) {
        return this.isNewCatalog.fields
      }
      return this.headers.map(h => this.mapLegacyField(h.text))
    }
  },
  methods: {
    mapLegacyField (key) {
      if (Object.prototype.hasOwnProperty.call(BOOLEAN_CATALOG_FIELDS, key)) {
        return { key, type: 'boolean' }
      }
      return { key, type: 'text' }
    },
    isBooleanField (field) {
      if (!field) return false
      if (field.type === 'boolean') return true
      return Object.prototype.hasOwnProperty.call(BOOLEAN_CATALOG_FIELDS, field.key)
    },
    booleanFieldLabel (key) {
      return BOOLEAN_CATALOG_FIELDS[key] || key
    },
    coerceBoolean (value) {
      if (typeof value === 'boolean') return value
      if (value === true || value === 1 || value === '1' || value === 'true' || value === 't' || value === 'TRUE') {
        return true
      }
      return false
    },
    hasBooleanFlags (payload) {
      return Object.keys(BOOLEAN_CATALOG_FIELDS).some(key =>
        Object.prototype.hasOwnProperty.call(payload, key)
      )
    },
    hasAtLeastOneBooleanFlag (payload) {
      return Object.keys(BOOLEAN_CATALOG_FIELDS).some(key => !!payload[key])
    },
    normalizeCatalogRow (row) {
      if (!row || typeof row !== 'object') return row
      const normalized = { ...row }
      Object.keys(BOOLEAN_CATALOG_FIELDS).forEach(key => {
        if (Object.prototype.hasOwnProperty.call(normalized, key)) {
          normalized[key] = this.coerceBoolean(normalized[key])
        }
      })
      return normalized
    },
    getFieldConfig (key) {
      return this.isNewCatalog
        ? this.isNewCatalog.fields.find(f => f.key === key)
        : null
    },
    isSelectField (key) {
      const f = this.getFieldConfig(key)
      return !!(f && f.type === 'select')
    },
    getSelectLabelProp (value, key) {
      const f = this.getFieldConfig(key)
      if (!this.selectOptions[key]) {
        return value
      }
      const item = this.selectOptions[key].find(aux => aux[f.value] === value)
      return item[f.label]
    },
    async loadAllFieldOptions () {
      this.loading = true
      for (let config of this.newCatalogs) {
        this.tableName = config.tabla
        await this.loadFieldOptions()
      }
      this.tableName = null
      this.loading = false
    },
    async loadFieldOptions () {
      // ¿qué config aplica? puede ser new o legacy; aquí el ejemplo para nuevos
      const config = this.isNewCatalog
      if (!config) return
      for (let f of config.fields) {
        if (f.type === 'select' && f.service && !this.selectOptions[f.key]) {
          // invocar tu helper ws (post)
          const params = f.serviceParams || {}
          const res = await this.ws(
            f.serviceMethod || 'post',
            f.service,
            params
          )
          if (res.ok) {
            this.selectOptions[f.key] = f.responseField
              ? res.data[f.responseField]
              : res.data.datos
          } else {
            this.selectOptions[f.key] = []
            console.error(`Error cargando ${f.service}:`, res.message)
          }
        }
      }
    },
    ws (method, name, data) {
      if (method === 'get') {
        if (this.$session.exists()) {
          let jwt = this.$session.get('jwt')
          let headers = {
            Authorization: 'Bearer ' + jwt
          }
          let params = ''
          for (let k in data) {
            params += k + '=' + data[k] + '&'
          }
          params = params !== '' ? '?' + params : ''
          return axios
            .get(services.routes[name] + params, { headers })
            .then(response => {
              let res = response.data
              if (res.correcto) {
                return { ok: true, data: res.data, message: res.mensaje }
              } else {
                return { ok: false, message: res.mensaje }
              }
            })
            .catch(error => {
              error.response.status === 403 && this.$router.push('/403')
              return {
                ok: false,
                message:
                  'El servicio no se encuentra disponible en estos momentos'
              }
            })
        } else {
          this.$router.push('/login')
        }
      } else {
        if (this.$session.exists()) {
          let jwt = this.$session.get('jwt')
          let headers = {
            Authorization: 'Bearer ' + jwt
          }
          return axios
            .post(services.routes[name], data, { headers })
            .then(response => {
              let res = response.data
              if (res.correcto) {
                return { ok: true, data: res.data, message: res.mensaje }
              } else {
                return { ok: false, message: res.mensaje }
              }
            })
            .catch(error => {
              error.response.status === 403 && this.$router.push('/403')
              return {
                ok: false,
                message:
                  'El servicio no se encuentra disponible en estos momentos'
              }
            })
        } else {
          this.$router.push('/login')
        }
      }
    },
    getCatalogNames () {
      this.loading = true
      this.ws('post', 'obtenerCatalogosDisponibles')
        .then(res => {
          if (res.ok) {
            const legacy = res.data
            this.catalogos.catalogos = [...legacy, ...this.newCatalogs]
          } else {
            this.error = true
            this.msgError = res.message
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    sortUsername (arr, mover, despuesDe) {
      if (!arr.includes(mover) || !arr.includes(despuesDe)) {
        return arr // no hacemos nada
      }

      const nuevo = arr.filter(k => k !== mover) // quitamos el campo a mover
      const idx = nuevo.indexOf(despuesDe)
      nuevo.splice(idx + 1, 0, mover) // lo insertamos después

      return nuevo
    },
    getCatalogEstatus () {
      this.loading = true
      this.ws('post', 'obtenerCatalogoEstatus')
        .then(res => {
          if (res.ok) {
            this.catalogos.catalogos_estatus_original = res.data.datos
            for (let i = 0; i < res.data.datos.length; i++) {
              this.catalogos.catalogos_estatus[res.data.datos[i].idcat_estatus] =
                res.data.datos[i].estatus
            }
          } else {
            this.error = true
            this.msgError = res.message
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    updateTable (event) {
      if (event) this.tableName = event
      if (!this.tableName) return

      // ¿es un catálogo nuevo?
      const isNew = this.newCatalogs.some(c => c.tabla === this.tableName)
      const loader = isNew
        ? this.fetchCatalog(this.tableName)
        : this.ws('post', 'obtenerCatalogo', { tableName: this.tableName })

      loader.then(res => {
        const raw = isNew ? res : res.data.datos

        // Para nuevos: raw es lista de objetos anidados
        // para legacy: raw = res.data.datos, titulos = res.data.titulos, editables = res.data.editables
        if (isNew) {
          let camposExcluidos = ['idusuario_creacion', 'idusuario_actualizacion', 'fecha_creacion', 'fecha_actualizacion']
          console.log(this.tableName)
          if (this.tableName === 'cat_puestos_gastos_representacion') {
            camposExcluidos.push('idusuario')
          }

          this.valores = raw.map(({ camposExcluidos
            , ...rest }) => ({
            ...rest
          }))

          let titulos = Object.keys(this.valores[0] || {}).filter(key => !camposExcluidos.includes(key))
          titulos = this.sortUsername(titulos, 'username', 'idcat_estatus')
          console.log('titulos', titulos)
          this.headers = titulos.map(t => ({
            text: t,
            value: t,
            align: 'center',
            sortable: false
          }))
          this.editables = titulos.reduce((a, t) => {
            a[t] = true
            return a
          }, {})
        } else {
          if (res.ok) {
            this.valores = (res.data.datos || []).map(row => this.normalizeCatalogRow(row))
            const titulos = res.data.titulos
            this.headers = titulos.map(t => ({
              text: t,
              value: t,
              align: 'center',
              sortable: false
            }))
            this.editables = res.data.editables.reduce((a, v, i) => {
              a[titulos[i]] = v
              return a
            }, {})
          } else {
            this.valores = []
            this.editables = []
          }
        }
      })
    },
    refresh () {
      this.getCatalogEstatus()
      this.getCatalogNames()
    },
    async showDetailElemnt (id) {
      // 1) Carga primero las options de todos los select necesarios
      await this.loadFieldOptions()

      // 2) Busca el item original y crea el objeto de detalle (asignación completa
      //    para que Vue 2 registre las propiedades como reactivas)
      const item = this.valores.find(el => el[this.headers[0].text] === id)
      if (!item) {
        this.error = true
        this.msgError = 'No se encontró el elemento seleccionado'
        return
      }

      const detalle = {}
      this.editFields.forEach(f => {
        if (this.isBooleanField(f)) {
          detalle[f.key] = this.coerceBoolean(item[f.key])
        } else {
          detalle[f.key] = item[f.key]
        }
      })

      if (this.isNewCatalog) {
        detalle[this.isNewCatalog.fieldToUpdate] =
          item[this.isNewCatalog.fieldToUpdate]
      }

      this.detalleCatalogo = detalle
      this.selectDetCat = id
      this.dialogDetCat = true
    },
    async showDialogNewCat () {
      await this.loadFieldOptions()
      const nuevo = {}
      this.newFields.forEach(f => {
        nuevo[f.key] = this.isBooleanField(f) ? false : ''
      })
      this.nuevoCatalogo = nuevo
      this.dialogNewCat = true
    },
    save () {
      this.questionCat = false
      const isNew = this.newCatalogs.some(c => c.tabla === this.tableName)
      const payload = { ...this.nuevoCatalogo }

      if (this.hasBooleanFlags(payload) && !this.hasAtLeastOneBooleanFlag(payload)) {
        this.error = true
        this.msgError = 'Debe marcar al menos un tipo de solicitud en "Aplicable a"'
        return
      }

      const action = isNew
        ? this.createCatalog(this.tableName, payload)
        : this.ws('post', 'nuevoElementoCatalogo', {
          tableName: this.tableName,
          valores: payload
        })

      action
        .then(res => {
          if (!isNew && res && res.ok === false) {
            this.error = true
            this.msgError = res.message || 'Error al guardar'
            return
          }
          this.success = true
          this.msgSuccess = 'Guardado correctamente'
          this.dialogNewCat = false
          this.updateTable(null)
        })
        .catch(e => {
          this.error = true
          this.msgError =
            (e.response && e.response.data && e.response.data.message) ||
            'Error al guardar'
        })
    },
    update () {
      this.questionUpdCat = false
      const isNew = this.newCatalogs.some(c => c.tabla === this.tableName)
      const payload = isNew
        ? { ...this.detalleCatalogo }
        : {
          tableName: this.tableName,
          elemnSeleccionado: this.selectDetCat,
          valores: this.detalleCatalogo
        }

      const valoresFlags = isNew ? payload : payload.valores
      if (this.hasBooleanFlags(valoresFlags) && !this.hasAtLeastOneBooleanFlag(valoresFlags)) {
        this.error = true
        this.msgError = 'Debe marcar al menos un tipo de solicitud en "Aplicable a"'
        return
      }

      const action = isNew
        ? this.updateCatalog(this.tableName, payload)
        : this.ws('post', 'actualizarElementoCatalogo', payload)

      action
        .then(res => {
          if (!isNew && res && res.ok === false) {
            this.error = true
            this.msgError = res.message || 'Error al actualizar'
            return
          }
          this.success = true
          this.msgSuccess = 'Actualizado correctamente'
          this.dialogDetCat = false
          this.updateTable(null)
        })
        .catch(e => {
          this.error = true
          this.msgError =
            (e.response && e.response.data && e.response.data.message) ||
            'Error al actualizar'
        })
    },
    remove () {
      this.questionDelCat = false
      const isNew = this.newCatalogs.some(c => c.tabla === this.tableName)
      const payload = isNew
        ? { ...this.detalleCatalogo }
        : { tableName: this.tableName, id: this.selectDetCat }

      const action = isNew
        ? this.deleteCatalog(this.tableName, payload)
        : this.ws('post', 'eliminarElementoCatalogo', payload)

      action
        .then(res => {
          if (!isNew && res && res.ok === false) {
            this.error = true
            this.msgError = res.message || 'Error al eliminar'
            return
          }
          this.success = true
          this.msgSuccess = 'Eliminado correctamente'
          this.dialogDetCat = false
          this.updateTable(null)
        })
        .catch(e => {
          this.error = true
          this.msgError =
            (e.response && e.response.data && e.response.data.message) ||
            'Error al eliminar'
        })
    },
    closeDetailCat () {
      this.dialogDetCat = false
      this.detalleCatalogo = {}
    },
    close () {
      this.dialogNewCat = false
    },
    fetchCatalog (tabla) {
      const jwt = this.$session.get('jwt')
      this.loading = true
      return axios
        .get(`${services.apiBase}/api/v1/${tabla}/list`, {
          headers: { Authorization: 'Bearer ' + jwt }
        })
        .then(resp => resp.data)
        .finally(() => {
          this.loading = false
        })
    },
    createCatalog (tabla, payload) {
      const jwt = this.$session.get('jwt')
      this.loading = true
      return axios
        .post(`${services.apiBase}/api/v1/${tabla}/create`, payload, {
          headers: { Authorization: 'Bearer ' + jwt }
        })
        .finally(() => {
          this.loading = false
        })
    },
    updateCatalog (tabla, payload) {
      const jwt = this.$session.get('jwt')
      this.loading = true
      return axios
        .post(`${services.apiBase}/api/v1/${tabla}/update`, payload, {
          headers: { Authorization: 'Bearer ' + jwt }
        })
        .finally(() => {
          this.loading = false
        })
    },
    deleteCatalog (tabla, payload) {
      const jwt = this.$session.get('jwt')
      this.loading = true
      return axios
        .post(`${services.apiBase}/api/v1/${tabla}/delete`, payload, {
          headers: { Authorization: 'Bearer ' + jwt }
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
